<template>
	<div class="container container-semifluid">
		<div class="modal-box-container">
			<div class="modal-box" :style="boxStyle">
				<div class="modal-container">
					<div class="close-button" @click="onClose()">
						<i class="fas fa-times"></i>
					</div>
					<header class="modal-container-header" v-if="$slots['header']">
						<slot name="header"></slot>
					</header>
					<main>
						<slot></slot>
					</main>
					<div class="modal-container-footer" v-if="$slots['footer']">
						<slot name="footer"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['onClose', 'boxStyle', 'withoutClose'],
	created() {
		document.body.className = 'modal-opened';
	},
	mounted() {
		window.addEventListener('keydown', this.onCloseKeyEvent.bind(this));
	},
	methods: {
		onCloseKeyEvent(e) {
			if (e.key === 'Escape') {
				this.onClose();
			}
		},
		onCloseOutSideArea(event) {
			// if click on anything except the modal itself, close the modal
			if (!event.target.closest('.modal-box')) {
				this.onClose();
			}
		},
	},
	beforeDestroy() {
		document.body.className = '';
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/themes/components/modal.scss";

</style>



// WEBPACK FOOTER //
// src/components/elements/Modal.vue